import React, { useState } from 'react';
import { ArrowLeft, ArrowRight, Quote } from 'lucide-react';
import { testimonials } from '../mock';
import useReveal from '../hooks/useReveal';

const Voices = () => {
  const ref = useReveal();
  const [idx, setIdx] = useState(0);

  const t = testimonials[idx];
  const next = () => setIdx((idx + 1) % testimonials.length);
  const prev = () => setIdx((idx - 1 + testimonials.length) % testimonials.length);

  return (
    <section id="voices" ref={ref} className="relative py-16 md:py-20 px-6 md:px-10 border-t border-white/5 overflow-hidden">
      {/* Vintage microphone background — the voice of the room */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <img
          src="/voices-mic.webp" srcSet="/voices-mic-400w.webp 400w, /voices-mic-800w.webp 800w, /voices-mic.webp 2000w" sizes="(max-width: 640px) 400px, (max-width: 1024px) 800px, 2000px" loading="lazy" decoding="async"
          alt=""
          className="w-full h-full object-cover object-center opacity-[0.42]"
        />
        <div className="absolute inset-0 bg-[color:var(--obsidian)]/55" />
        <div className="absolute inset-0 bg-gradient-to-b from-[color:var(--obsidian)] via-transparent to-[color:var(--obsidian)]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_0%,rgba(10,10,10,0.4)_70%,rgba(10,10,10,0.9)_100%)]" />
      </div>

      <div className="pointer-events-none absolute -left-16 top-40 w-[380px] h-[380px] rounded-full bg-[color:var(--parchment)]/[0.05] blur-3xl" />

      <div className="relative max-w-[1300px] mx-auto">
        <div className="reveal font-mono text-[12px] md:text-[10.5px] tracking-[0.24em] uppercase text-[color:var(--green)] mb-4">
          &mdash; Client Voices
        </div>
        <h2 className="reveal font-display text-[38px] md:text-[64px] leading-[1.02] text-[color:var(--parchment)] max-w-4xl">
          The <span className="text-[color:var(--green)]">Ionic difference</span>, in our clients&rsquo; own words.
        </h2>

        <div className="reveal mt-14 grid md:grid-cols-[.75fr_.25fr] gap-10 items-start">
          <div className="relative">
            <Quote className="w-10 h-10 text-[color:var(--green)] mb-4" />
            <blockquote className="font-display text-[24px] md:text-[40px] leading-[1.25] text-[color:var(--parchment)] min-h-[300px]">
              &ldquo;{t.quote}&rdquo;
            </blockquote>
            <div className="mt-8 pt-6 border-t border-white/10 flex items-center justify-between flex-wrap gap-4">
              <div>
                <div className="font-display text-lg text-[color:var(--parchment)]">{t.name}</div>
                <div className="font-mono text-[12px] md:text-[10.5px] tracking-[0.22em] uppercase text-[color:var(--parchment)]/55 mt-1">{t.role} · {t.estate}</div>
              </div>
              <div className="flex items-center gap-3">
                <button
                  onClick={prev}
                  className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center text-[color:var(--parchment)] hover:border-[color:var(--green)] hover:text-[color:var(--green)] transition-colors"
                  aria-label="Previous"
                >
                  <ArrowLeft className="w-4 h-4" />
                </button>
                <span className="font-mono text-[11px] tracking-[0.22em] uppercase text-[color:var(--parchment)]/55">
                  {String(idx + 1).padStart(2, '0')} / {String(testimonials.length).padStart(2, '0')}
                </span>
                <button
                  onClick={next}
                  className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center text-[color:var(--parchment)] hover:border-[color:var(--green)] hover:text-[color:var(--green)] transition-colors"
                  aria-label="Next"
                >
                  <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>

          <div className="md:border-l md:border-white/10 md:pl-8">
            {testimonials.map((v, i) => (
              <button
                key={v.estate}
                onClick={() => setIdx(i)}
                className={`block w-full text-left py-4 border-b border-white/10 transition-colors ${i === idx ? 'text-[color:var(--parchment)]' : 'text-[color:var(--parchment)]/50 hover:text-[color:var(--parchment)]/80'}`}
              >
                <div className="flex items-center gap-3">
                  <span className={`font-mono text-[12px] md:text-[10.5px] tracking-[0.22em] uppercase ${i === idx ? 'text-[color:var(--green)]' : ''}`}>
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span className="font-display text-[15px] leading-tight">{v.estate}</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Voices;
